import * as React from "react";
import FormikAutocompleteField from "../../formik/FormikAutocomplete";
import PropTypes from "prop-types";
import { HttpClientConfig } from "../../../utils/HttpClient";

export const ProductCategoryAutocomplete = (props) => {
  const lookupUrl = `${HttpClientConfig.baseURL}/ProductCategory/Lookup`;
  const lookupByIdUrl = `${HttpClientConfig.baseURL}/ProductCategory/LookupById`;

  const handleAddClick = (e) => {
    console.log(e);
  }

  return (
    <FormikAutocompleteField {...props} lookupUrl={lookupUrl} lookupByIdUrl={lookupByIdUrl} onAddButtonClick={handleAddClick} />
  );
};

ProductCategoryAutocomplete.propTypes = {
  fieldName: PropTypes.string,
  label: PropTypes.string,
  formik: PropTypes.any
}

export default ProductCategoryAutocomplete;
